module.exports = __webpack_public_path__ + "AnnaTheNewtShop.jpg?9f5f514cc4c53c9c1532a89b2f447505";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/AnnaTheNewtShop.jpg
// module id = 439
// module chunks = 0